import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../client';

export const getNewAlertsNotification = createAsyncThunk(
  'alerts/getNewAlertsNotification',
  async (accountUuid) => {
    return await client.get(
      `/accounts/${accountUuid}/alerts-aggregate`,
    );
  },
);

export const getAlertTags = createAsyncThunk(
  'alerts/getAlertTags',
  async () => {
    return await client.get(
      `/accounts/alerts/tags`,
    );
  },
);

export const sendViewedAlertsUuids = createAsyncThunk(
  'alerts/sendViewedAlertsUuids',
  async ({ accountUuid, viewedAlertsUuids }) => {
    return await client.post(
      `/accounts/${accountUuid}/alerts-actions`,
      {
        'action': 'view',
        'alertsUUIDs': viewedAlertsUuids,
      },
    );
  },
);

export const getEndpointChangeAlertAcknowledgeStatus = (accountUuid) => `/accounts/${accountUuid}/alerts-actions`;
